/**
 * Returns a function to retrieve the mapStateToProps for a certain named product group
 * This is used for the material requests on the material page
 * @param {string} group 
 */
export const pageresultState = group => name => state => {
  return { pageresult: state.products[group + '/' + name] };  
};